const zh_tw = {
  task: {
    center: "任務中心",
    callTask: "通話任務",
    giftTask: "禮物任務",
    liveTask: "新人任務",
    sevenTask: "7日任務",
    callMessage: "接通更多電話以獲得獎勵",
    giftMessage: "收取禮物以獲得獎勵",
    liveMessage: "增加<span class='web'>Live</span>時長贏取{d}獎勵",
    sevenMessage: "完成每日任務贏取{d}獎勵",
    cellTitle: "通話≥{d}分鐘（次數）",
    reward: "獎勵",
    lastWeek: "上週獎勵:",
    weekGift: "本周禮物收益:",
    RewardDescription: "獎勵說明",
    everyWeekGift: "本周禮物收益<span class='web'>(Bonus)</span>",
    endTask: '任務已結束',
    query: "確定"
  },
  message: {
    taxt1: "1. 結算週期為每週一至週日，視頻通話時長≥{d}分鐘次數越多，獎勵越豐厚。",
    taxt2: "2. 每週最多只能獲得一個檔位的獎勵，根據你當週單次通話時間≥{d}分鐘的次數評定。",
    taxt3: "3. 經官方核實後，獎勵將在結算後的下週四前，發放至您的收入賬戶。",
    taxt4: "4. 如發現作弊行為，則取消獎勵資格。",
    taxt5: "5. 有任何疑問請諮詢官方：<span class='web'>support@honeycamweb.com</span>",
    hint: "注：以國際時間為準",
    rewardOne1: "1.任務開啟7天內",
    rewardOne2: "1) 至少有6天每天<span class='web'>live</span>≥2小時，接通率≥{d}",
    rewardOne3: "2) 任務開啟7天內，總收益達到≥{d}<span class='web'>Bonus</span>",
    rewardOne4: "3) 以上條件同時滿足，任務結束後可獲得平台獎勵<span style='color: #ff2794'>{d}</span>;",
    rewardOne5: "2.一個主播至多獎勵一個賬號，多賬號無效;",
    rewardOne6: "3.如果發現作弊行為，則取消獎勵資格;",
    rewardOne7: "4. 完成任務的用戶，任務結束後。關注官方<span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>主頁，添加小組即可獲取<span style='color: #ff2794'>$10</span>獎勵",
    rewardOne8: "5.有任何疑問請諮詢官方：<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "任務期間當日收益超過$10的用戶，有機會第二天進入推薦或熱門頁的頂置位，獲得更多曝光;"
  },
  gift: {
    test1: "1. 結算週期為每週一至週日，獲得禮物越多，獎勵越豐厚。",
    test2: "2. 每週最多只能獲得一個檔位的獎勵，檔位根據當週總收入進行評定。",
    test3: "3. 經官方核實後，獎勵將在結算後的下週四前，發放至您的收入賬戶。",
    test4: "4. 如發現作弊行為，則取消獎勵資格。",
    test5: "5. 有任何疑問請諮詢官方：<span class='web'>support@honeycamweb.com</span>",
    giftNum: "收禮物≥{d}個",
    totalBonus: "收益≥{d}<span class='web'>Bonus</span>",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "通話≥{d}(m)",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "獎勵一",
    rewardTwo: "獎勵二",
    start: "今日0點任務正式開啟",
    hint: "每日保持<span class='web'>Live</span>≥{d}小時，接通率≥{d}即可獲得獎勵{d}。",
    tastReward: "任務期間總收益<span class='web'>Bonus</span>",
    liveTime: "今日<span class='web'>live</span>時長",
    callRate: "今日接通率",
    progress: "任務進度",
    endRate: "(目標≥",
    overText1: "恭喜任務完成",
    overText2: "關注官方<span class='web'>Facebook \"Honeycam\"</span> ，添加小組獲取{d}獎勵。",
    overText3: "很遺憾任務沒有完成，無法獲得{d}獎勵。",
    overText4: "關注官方<span class='web'>Facebook \"Honeycam\"</span> ，獲取更多任務活動信息。",
    openfb: "打開<span class='web'>Facebook</span>",
  },
  week: {
    live30: "明日<span class='web'>live</span>≥{d}分鐘",
    call5: "明日通話≥5分鐘",
    rewardHint: "(以下任務全部完成，<span style='color: #ff2794'>额外奖励<span class='web'>$20</span></span>)",
    newLive: "今日<span class='web'>Live</span>",
    newLiveSec: "(目標≥{d})",
    newCall: "今日通話",
    newCallRate: "今日接通率",
    newBonus: "今日收益<span class='web'>Bonus</span>",
    newGift: "今日禮物個數",
    newReward: "今日獎勵",
    days: "天數",
    taskReq: "任務要求",
    task1: "1.每天任務都在0點統一結算，0點發放至你的<span class='web'>Bonus</span>賬戶",
    task2: "2.如當天任務未完成，則任務失敗。失敗的任務無法重新進行;",
    task3: "3.只有7天任務全部完成時，可獲得{d}獎勵禮包;",
    task4: "4.一個主播至多獎勵一個賬號，多賬號無效;",
    task5: "5.如果發現作弊行為，則取消獎勵資格;",
    task6: "6.完成任務的用戶，任務結束後。關注官方<span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>主頁，添加小組獲取<span style='color: #ff2794' class='web'>$20</span>獎勵",
    task7: "7.有任何疑問請諮詢官方：<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default zh_tw;
